<style lang="scss" src='./SpotCheckDevice.scss' scoped></style>
<template src="./SpotCheckDevice.html"></template>

<script>
export default {
  name: "SpotCheckDevice",
  components: {},

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {
    if (process.env.VUE_APP_SENTRY_ENV == "production") {
      this.$analytics.setCurrentScreen("Web Sync");
      this.$analytics.logEvent("web_sync");
    }
  },

  beforeDestroy() {},
};
</script>
